import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HolidayUmbrellaGlyph = /*#__PURE__*/createElement("g", {
  id: "holiday_umbrella"
}, /*#__PURE__*/createElement("path", {
  d: "M65,65.8c-0.4,0-0.8-0.1-1.1-0.4L39.8,41.2c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0L66,63.2c0.6,0.6,0.6,1.5,0,2.1 C65.7,65.6,65.3,65.8,65,65.8z"
}), /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M22.9,30.3c-7,10.1-7.3,22.5-0.1,29.8l4.9-4.9L22.9,30.3z"
}), /*#__PURE__*/createElement("path", {
  d: "M58.1,25.3l3.6-3.6c-7.5-7.6-20.6-7.1-30.9,0.5L58.1,25.3z"
}), /*#__PURE__*/createElement("polygon", {
  points: "53.6,29.7 27.2,26.8 31.9,51.1 \t\t"
})));
const HolidayUmbrella = createSvg({
  name: 'holiday_umbrella',
  path: HolidayUmbrellaGlyph
});

export default HolidayUmbrella;
export { HolidayUmbrellaGlyph };
